<template>
  <section class="sync">
    <div class="sync__container">
      <div class="sync-form__auth">
        <p class="sync-form__heading">
          Byte Channel Pages
          <i class="tooltip-icon fas fa-question-circle" v-tooltip="'Custom Byte pages curated based on your filter selections, irrespective of your Learning Content customizations.'"></i>
        </p>
        <div class="projects__list--filter">
          <rum-input icon="fa fa-search" class="projects__search" v-model="searchQuery" placeholder="Search..." clearable />
          <rum-button class="project__add-button" @click="showAddChannelModal()"><img src="@/assets/images/plus.svg">Add Channel</rum-button>
        </div>
        <div class="server__container">
        <rum-loader v-if="loading" class="people-card__loader" center/>
        <div v-else-if="noChannel" class="server__empty">
          There are no Channel Pages available, please add one.
        </div>
        <div class="project__container" v-else>
          <table class="server__table">
            <thead>
              <tr class="server-table__row">
                <th></th>
                <th class="channel__name">Name</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <container tag="tbody" group-name="drag" @drop="onChannelReorder">
              <draggable tag="tr" class="server-table__data" v-for="(channel, index) in filteredChannels" :key="index">
                <td class="channel__movehandle">
                  <img src="@/assets/images/sort-handle.svg" />
                </td>
                <td>
                  <span>
                    <span class="server-action__item">{{index+1}}</span>
                    <span style="color: black; margin-left: var(--spacing-4);">{{channel.name}}</span>
                  </span>
                </td>
                <td>
                  <a class="server__action" target="_blank" :href="`${projectUrl}/channels/${channel.slug}`">
                    <span class="server-action__label">
                      <img src="@/assets/images/eye.svg" class="eye__image" />
                      View Channel
                    </span>
                  </a>
                </td>
                <td>
                  <div class="server__action" @click="showCopyCodeModal(channel)">
                    <span class="server-action__label">
                      <i class="far fa-code"></i>
                      Embed Code
                    </span>
                  </div>
                </td>
                <td>
                  <div class="server__action" @click="copyChannel(channel)">
                    <span class="server-action__label">
                      <i class="far fa-copy server-action__item"></i>
                      Copy Channel link
                    </span>
                  </div>
                </td>
                <td>
                  <div class="server__action" @click="showEditChannelModal(channel)">
                    <span class="server-action__label">
                      <i class="far fa-edit server-action__item"></i>
                      Edit
                    </span>
                  </div>
                </td>
              </draggable>
            </container>
          </table>
        </div>
      </div>
      </div>
    </div>
    <channel-add-edit-modal @refresh="fetchChannels()" />
    <copy-code-modal />
  </section>
</template>

<script>
import api from "@/api";
import throttle from "lodash/throttle";
import { Container, Draggable } from "vue-smooth-dnd";
import ChannelAddEditModal from "@/components/ProjectConnect/ChannelAddEditModal";
import CopyCodeModal from "@/components/ProjectConnect/CopyCodeModal";

export default {
  components: { Container, Draggable, ChannelAddEditModal, CopyCodeModal },
  name: "ManageChannels",
  props: {
    project: Object
  },
  data() {
    return {
      loading: false,
      channels: [],
      searchQuery: ""
    };
  },
  computed: {
    downloadQRImageName() {
      return `project_${this.projectId}_qrcode`
    },
    validFormatForQR() {
      return this.projectUrl;
    },
    projectId() {
      return this.$route.params.id;
    },
    noChannel() {
      return this.channels.length <= 0;
    },
    projectUrl() {
      return `${this.$store.getters['projectEdit/projectUrl']}${this.project.encodedID}`;
    },
    filteredChannels() {
      return this.channels.filter(a=>(a.name.toLowerCase()).includes(this.searchQuery.toLowerCase()))
    },
  },
  methods: {
    async onChannelReorder({removedIndex, addedIndex}) {
      if (removedIndex === null) return;
      const result = [...this.channels];

      let itemToAdd;
      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }
      if(addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
        this.channels = result;
        this.channels.length > 0 && this.channels.forEach((channel, index) => {
          this.filterArrivingFormat(channel, index);
        })
      }
      this.$notify({
        type: "success",
        title: "Channel sorted successfully."
      });
    },
    copyChannel(channel) {
      let channelLink = `${this.projectUrl}/channels/${channel.slug}`
      this.$copyToClipboard(channelLink);
      this.$notify({
        type: "success",
        title: "Channel link copied successfully"
      });
    },
    downloadQR() {
      const element = document.getElementById("qr-code");
      element.click();
    },
    printQR() {
      const element = document.getElementById("qr-code").innerHTML;
      var printWindow = window.open('', '', 'height=800,width=800');
      printWindow.document.write(element);
      printWindow.document.close();
      const title = printWindow.document.title = `Project - ${this.project.name} - QR Code`;
      const heading = printWindow.document.createElement('h1');
      const text = printWindow.document.createTextNode(title);
      heading.appendChild(text);
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '@page { size: auto;  margin: 0mm; }';
      heading.setAttribute('style', 'order: -1; margin-bottom: 50px;');
      printWindow.document.body.appendChild(heading);
      printWindow.document.body.appendChild(style);
      printWindow.document.body.setAttribute('style', 'display: grid; width: 100%; justify-items: center; margin: 0;');
      printWindow.print();
    },
    editProjectThrottled: throttle(function() {
      this.editProject();
    }, 2500),
    copyText(text) {
      this.$copyToClipboard(text);
      this.$notify({
        type: "success",
        title: "Text copied successfully"
      });
    },
    showAddChannelModal() {
      this.$modal.show("channel-add-edit-modal");
    },
    showEditChannelModal(channel) {
      this.$modal.show("channel-add-edit-modal", { channel });
    },
    showCopyCodeModal(channel) {
      this.$modal.show("copy-code-modal", { channel });
    },
    showEditServerModal(server) {
      this.$modal.show("server-create-edit-modal", { server });
    },
    async editChannel(index, channel, filteredFormat) {
      try {
        const current  = api('v3');
        await current.post(`connect/projects/${this.projectId}/channels/${channel.id}`, {
          name: channel.name,
          description: channel.description,
          icon: channel.icon,
          filter: JSON.stringify(filteredFormat),
          sort: index
        });
      } catch (error) {
        console.log(error);
        const errorMessage = error.response.data.message;
        this.$notify({
          type: "error",
          title: errorMessage || "Failed to sort channel, please try again."
        });
      }
    },
    filterArrivingFormat(channel, index) {
      let orgs = [];
      if(channel.filter.orgs.length > 0) {
        orgs = channel.filter.orgs.map(org=> {
          return {...org, "type":"org"}
        })
      }
      let tags = [];
      if(channel.filter.tags.length > 0) {
        tags = channel.filter.tags.map(tag=> {
          return {...tag, "type":"tag"}
        })
      }
      let authors = [];
      if(channel.filter.authors.length > 0) {
        authors = channel.filter.authors.map(author=> {
          return {...author, "type":"author"}
        })
      }
      let filterFormat = [];
      filterFormat = filterFormat.concat(orgs, tags, authors);
      this.filterSendingFormats(filterFormat, channel, index)
    },
    filterSendingFormats(filters, channel, index) {
      let filteredFormat = filters.map(filter => {
        return {"type": filter.type, "id": filter.id}
      })
      this.editChannel(index, channel, filteredFormat);
    },
    async fetchChannels() {
      const current = api('v3');
      this.loading = true;
      const { data } = await current.get(`connect/projects/${this.projectId}/channels`);
      this.channels = data.sort((a, b) => (a.sort > b.sort ? 1 : b.sort > a.sort ? -1 : 0)) || [];
      this.loading = false;
    },
  },
  mounted() {
    this.fetchChannels();
  }
};
</script>

<style scoped>
.sync {
  padding-bottom: 75px;
}

.sync-container {
  display: flex;
  flex-direction: column;
  height: auto;
  width: 50%;
}

.sync__form {
  display: flex;
  justify-content: space-between;
  background: var(--white);
  margin: var(--spacing-4);
  padding: var(--spacing-4);
  box-shadow: var(--shadow-primary);
  margin-bottom: 0;
}

.sync-form__heading,
.sync-instructions__heading {
  font-weight: var(--bold);
  color: var(--black);
}

.projects__list--filter {
  display: flex;
  justify-content: space-between;
}

.project__add-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--spacing-3) var(--spacing-6) !important;
  font-size: var(--sm) !important;
  margin-left: 15px;
}

.project__add-button img {
  margin-right: var(--spacing-2);
}

.sync__project-details {
  display: flex;
}

.sync__project-details > div {
  margin-right: var(--spacing-4);
}

.sync-auth {
  display: flex;
  align-items: center;
}

.sync-auth__id {
  min-width: 320px;
}

.sync-auth__label {
  cursor: pointer;
  margin-left: var(--spacing-4);
  margin-bottom: var(--spacing-0) !important;
}

.project-url {
  text-decoration: none;
  color: var(--primary);
}

.sync-form__row {
  margin-top: var(--spacing-6);
  margin-left: calc(-1 * var(--spacing-4));
  padding-left: var(--spacing-4);
}

.sync-container__config {
  padding-bottom: var(--spacing-8);
}

.sync-form__border {
  border-bottom: var(--border-2) solid var(--grey-lighter);
  margin: var(--spacing-6) calc(-1 * var(--spacing-4));
}

.sync-form__auth {
  padding: var(--spacing-4);
  margin: var(--spacing-4);
  background-color: var(--white);
}

.qrcode__container {
  display: flex;
  margin-top: var(--spacing-4);
}

.qrcode__print {
  margin-left: var(--spacing-12);
}

.qrcode-container__code {
  margin-top: var(--spacing-6);
  margin-left: auto;
}

.channel__movehandle {
  cursor: pointer;
  max-width: 25px;
  color: var(--black);
}

.sync__container {
  width: 100%;
}

.server__add-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--spacing-3) var(--spacing-6) !important;
  font-size: var(--sm) !important;
}

.server__add-button img {
  margin-right: var(--spacing-2);
}

.project__container {
  overflow-x: auto;
  background-color: var(--white);
  margin-top: var(--spacing-4);
  min-width: 600px;
}

.server__empty {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--base);
  color: var(--grey);
  background: var(--white);
  height: 100%;
  text-align: center;
  margin: var(--spacing-4) 0  ;
}

.server__table {
  border-collapse: collapse;
  width: 100%;
}

.server__container {
  overflow-x: auto;
  background-color: var(--white);
  padding-bottom: var(--spacing-2);
}

th {
  padding: var(--spacing-4);
  font-size: var(--xs);
  text-align: left;
  color: var(--grey-dark);
}

td {
  padding: var(--spacing-4);
  font-size: var(--sm);
  text-align: left;
  color: var(--grey-dark);
}

.server-table__row {
  background: var(--grey-lighter);
}

.channel__name {
  width: 45%;
}

.server-table__data {
  border-bottom: var(--border-2) solid var(--grey-lighter);
}

.server__action {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: var(--primary);
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: none;
  min-width: 50px;
}

.server__action:disabled {
  opacity: var(--opacity-50);
  cursor: not-allowed;
}

.server-action__item {
  font-size: var(--base);
}

.server-action__label {
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.eye__image {
  margin-right: 5px;
  width: 18px;
}

.far {
  margin-right: 5px;
}

@media screen and (max-width: 1200px) {
  .sync {
    flex-direction: column;
  }

  .sync-container {
    width: 100%;
  }

  .sync__container {
    width: 100%;
  }
}

@media screen and (max-width: 860px) { 
  .channel__name {
    width: 25%;
  }
}

@media screen and (max-width: 700px) {
  .sync {
    flex-direction: column;
  }

  .sync-container {
    width: 100%;
  }

  .sync__project-details {
    display: block;
  }

  .sync__project-details > div {
    margin-right: var(--spacing-0);
  }

  .qrcode__container {
    display: block;
  }

  .qrcode-container__code {
    margin-left: var(--spacing-0);
    margin-top: var(--spacing-6);
  }

  .sync__container {
    width: 100%;
  }

  .projects__list--filter {
    flex-direction: column;
  }

  .project__add-button {
    margin-left: 0;
    margin-top: var(--spacing-4);
  }
}

@media screen and (max-width: 450px) {

  .sync-auth {
    flex-direction: column;
    align-items: unset;
  }

  .sync-auth__id {
    min-width: unset;
  }

  .sync-auth__label {
    margin-top: var(--spacing-2);
    margin-left: auto;
    margin-right: auto;
  }

  .qrcode__print {
    margin-left: var(--spacing-0);
    margin-top: var(--spacing-4);
  }

  .qrcode__button {
    display: flex;
    flex-direction: column;
  }
}
</style>
